module.exports = function () {
  return "<div class=\"poker-main\" id=\"poker-main\"></div>";
};